import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QrcodeProcessPage} from '../qrcode-process.page';
import {LoadingController, ModalController, NavController} from '@ionic/angular';
import {ApiService} from '../../../services/api.service';
import {ToastService} from '../../../services/toast.service';
import {ValidateProductModalComponent} from '../../../modal/validate-product-modal/validate-product-modal.component';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.page.html',
  styleUrls: ['./transfer.page.scss'],
})
export class TransferPage implements OnInit {

  qrcode: any;
  products: any;
  tranferForm: FormGroup;
  currentUser: any;
  seeall = false;


  constructor(@Inject(QrcodeProcessPage) private parent: QrcodeProcessPage, private navController: NavController, private apiService: ApiService, private loadingController: LoadingController, private toastService: ToastService, private modalController: ModalController) {
    this.qrcode = this.parent.qrcode;
    this.products = this.parent.product;

    this.currentUser = this.apiService.authApi.currentUser;
  }

  changeSee(see){
    if (see){
      this.tranferForm.controls.name.setValidators(Validators.compose(
          [Validators.required]));
      this.tranferForm.controls.name.updateValueAndValidity();
    } else {
      this.tranferForm.controls.name.setValue(null);
      this.tranferForm.controls.name.clearValidators();
      this.tranferForm.controls.name.updateValueAndValidity();
    }
    this.seeall = see;
  }

  ngOnInit() {
    this.tranferForm = new FormGroup({
      name: new FormControl('', Validators.compose([]))
    });
  }

  goBack(){
    this.navController.navigateBack('/home/' + this.qrcode + '/product');
  }

  async doAction(){
    if (this.tranferForm.invalid) {
      this.tranferForm.markAllAsTouched();
      return;
    }

    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    const d: any = {
      email : this.tranferForm.controls.name.value,
      paravol_number : this.qrcode,
    };
    if (this.seeall){
      this.apiService.qrcodeApi.transfer(d).then((e: any) => {
        this.toastService.success('Transfert effectué');
        this.navController.navigateBack('/home');
        loading.dismiss();
      }).catch(() => {
        this.toastService.error('Compte inexistant');
        loading.dismiss();
      });
    } else {
      this.navController.navigateForward('/home/' + this.qrcode + '/owner');
      loading.dismiss();
    }
  }

  async openModal(){
    const modal = await this.modalController.create({
      component: ValidateProductModalComponent,
      cssClass: 'validateProductModalFromTransfer',
      componentProps: {
        qrcode: this.qrcode,
        fromTransfer: true
      }
    });

    modal.onDidDismiss().then((result) => {
      if (result.data == 'repeat'){
        this.navController.navigateBack('/home/' + this.qrcode + '/repeat');
      }
      else{
        this.navController.navigateBack('/home');
      }

    }).catch(e => {
      this.navController.navigateBack('/home/' + this.qrcode + '/forbidden');
    });

    return await modal.present();
  }

  quit(){
    this.navController.navigateBack('/home');
  }
}
